import type { ReactNode } from "react";

/**
 * A stack of disclosure items on native <details>: no script at
 * all. Items sharing a `name` open one at a time.
 */
export function Accordion({
  id,
  label,
  className,
  children,
}: {
  id?: string;
  /** Names the group of disclosures for screen readers. */
  label?: string;
  className?: string;
  children: ReactNode;
}) {
  return (
    <div
      id={id}
      className={["ui-accordion", className].filter(Boolean).join(" ")}
      data-ui="accordion"
      role={label ? "group" : undefined}
      aria-label={label}
    >
      {children}
    </div>
  );
}

/** One item of an Accordion, or a standalone collapsible. */
export function AccordionItem({
  id,
  title,
  name,
  open = false,
  children,
}: {
  id?: string;
  title: string;
  /** Items sharing a name open one at a time. */
  name?: string;
  open?: boolean;
  children: ReactNode;
}) {
  return (
    <details id={id} className="ui-accordion-item" data-ui="accordion-item" name={name} open={open}>
      <summary className="ui-accordion-trigger">
        <span>{title}</span>
        <svg
          className="ui-accordion-icon"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="m6 9 6 6 6-6"></path>
        </svg>
      </summary>
      <div className="ui-accordion-panel">{children}</div>
    </details>
  );
}
